/**
 * Account-TrackingInfo Queries
 */
import gql from 'graphql-tag'

export const getTrackingInfoQuery = gql`
  query GetTrackingInfo($code: String!) {
    trackingInfo: getTrackingInfo(code: $code)
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/TrackingInfo/data.ts